import React, { useState, useEffect } from 'react';
import bookmaker from '../../../../assets/icons/bookmaker-svgrepo-com.svg';
import { BiPlus } from 'react-icons/bi';
import { HiPencil } from 'react-icons/hi';
import { CgClose } from 'react-icons/cg';
import Modal from '../../../../../components/Modal';
import TextAreaEditor from '../../../../../components/Form/TextAreaEditor';
import Input from '../../../../../components/Form/Input';
import Select from '../../../../../components/Form/Select';
import axios from 'axios'
import { region, district } from "../../../../datas/RegionDistrict"
import {RESUME_API_END_POINT as api} from "../../../../../utils/constant"
import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack';

const Expérience = ({data, setData}) => {
    const [experiences, setExperiences] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [currentExperience, setCurrentExperience] = useState(null);
    const {user} = useSelector(store=>store.user)
    const {showNotif, setShowNotif} = useOutletContext()
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({
            company: '',
            title: '',
            job_type: '',
            address: '',
            start_month: '',
            start_year: '',
            end_month: '',
            end_year: '',
            description: ''
    });

    useEffect(() => {
        if (data) {
            setExperiences(data?.experiences)
        }
        }, [data]);

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        };

    const handleAddExperience = async (experience) => {
        // setExperiences({...experience, resume_id: data?.id})
       
        const dataToSend = {...experience, resume_id:data?.id}
        console.log('Adding experiment', dataToSend);
        try {
            const response = await axios.post(`${api}/experiences/save`, dataToSend);
            if (response.data?.experience) {
            setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
            setExperiences([...experiences, response.data?.experience]);
            setShowAddModal(false);            
        }
        setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.error('Failed to add experience', error);
        }
    };

    const handleEditExperience = async (experience) => {
        setIsLoading(true)
        console.log("Update data", experience)
        try {
            const response = await axios.put(`${api}/experiences/${experience.id}`, experience);
            if (response.data?.experience) {
                setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
                setExperiences(experiences?.map(exp => exp.id === experience.id ? response.data?.experience : exp));
                // setData(prev => ({
                //     ...prev,
                //     experiences: prev?.experiences?.map(exp => exp.id === experience.id ? response.data?.experience : exp)
                // }));
                setShowEditModal(false);
            }
        setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
            console.error('Failed to update experience', error);
        }
    };
    

    const handleDeleteExperience = async (id) => {
        try {
            await axios.delete(`${api}/experiences/${id}`);
            setExperiences(experiences.filter(exp => exp.id !== id));
        } catch (error) {
            console.error('Failed to delete experience', error);
        }
    };

    const openEditModal = (experience) => {
        // setCurrentExperience(experience);
        setFormData((prev) => ({ ...prev, ...experience }));
        setShowEditModal(true);
    };

    return (
        <div className="flex-col text-start border p-4 rounded-md">
            <div className="flex justify-between items-center mb-4">
                <div className='font-semibold'>Expérience</div>
                <button onClick={() =>{
                    setFormData(null);
                    setShowAddModal(true)
                   
                }} className="bg-neutral-50 border rounded-sm p-1">
                    <BiPlus className='w-5 h-5 text-neutral-500' />
                </button>
            </div>
            
            {experiences?.map((exp, index) => (
                <div key={exp.id} className={(index !== experiences.length - 1) ? "border-b py-4 flex gap-4 items-start w-full mb-4" : "border-none pt-4 flex gap-4 items-start w-full mb-4"}>
                    <img src={bookmaker} alt="entreprise" className='w-12 h-12 rounded-full bg-gray-50 border' />
                    <div className='w-full'>
                        <div className="flex justify-between items-end mb-2">
                            <div className="text-start flex-col">
                                <h6 className='font-semibold'>{exp.title}</h6>
                                <div className="inline-block gap-2 text-sm">
                                    {exp.location} . {exp.company}
                                </div>
                            </div>
                            <p className='text-sm'>{exp.startYear}-{exp.endYear}</p>
                            <button onClick={() => openEditModal(exp)} className="bg-neutral-50 border rounded-sm p-1">
                                <HiPencil className='w-5 h-5 text-neutral-500' />
                            </button>
                        </div>
                        <p className='text-primary-text'>{exp.description}</p>
                    </div>
                </div>
            ))}

            {/* Modal for adding an experience */}
            <ExperienceModal
                isLoading={isLoading}
                isOpen={showAddModal}
                onClose={() => setShowAddModal(false)}
                onSave={handleAddExperience}
                title="Ajouter une expérience"
                handleChange={handleChange}
                formData={formData}
                setValue={(value) => setFormData({ ...formData, description: value })} 
            />

            {/* Modal for editing an experience */}
            <ExperienceModal
                isLoading={isLoading}
                isOpen={showEditModal}
                onClose={() => setShowEditModal(false)}
                onSave={handleEditExperience}
                handleChange={handleChange}
                experience={currentExperience}
                title="Modifier une expérience"
                formData={formData}
                setFormData={(value)=>setFormData(value)}
                setValue={(value) => setFormData({ ...formData, description: value })} 
            />
        </div>
    );
};

const ExperienceModal = ({isLoading, isOpen, onClose, onSave, experience, title, formData, setFormData, handleChange, setValue }) => {
    // const [formData, setFormData] = useState(null);

//     useEffect(() => {
//         // if (experience?.id) {
//         //     console.log(experience)
//         //     setFormData((prev) => ({
//         //         id: experience.id,
//         //         resume_id: experience.resume_id || '',
//         //         company: experience.company || '',
//         //         title: experience.title || '',
//         //         job_type: experience.job_type || '',
//         //         address: experience.address || '',
//         //         start_month: experience.start_month || '',
//         //         start_year: experience.start_year || '',
//         //         end_month: experience.end_month || '',
//         //         end_year: experience.end_year || '',
//         //         description: experience.description || ''
//         //     }));
//         // }
// // if(!formData){
//         if (experience?.id) {
//             console.log(experience)
//             setFormData((prev) => ({ ...prev, ...experience }));
//         } else {
//             setFormData({
//                 company: 'commp',
//                 title: '',
//                 job_type: '',
//                 address: '',
//                 start_month: '',
//                 start_year: '',
//                 end_month: '',
//                 end_year: '',
//                 description: ''
//             });
//         }
//     // }
//     }, [experience]);

// const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
// };

    const handleSubmit = () => {
        onSave(formData);
        // setFormData({
        //     company: '',
        //     title: '',
        //     job_type: '',
        //     address: '',
        //     start_month: '',
        //     start_year: '',
        //     end_month: '',
        //     end_year: '',
        //     description: ''
        // });
    };
    const months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];

    // Generate years from 1980 to the current year
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1980 + 1 }, (_, i) => (1980 + i).toString());

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="flex items-center justify-between py-2 px-4">
                <p>{title}</p>
                <button onClick={onClose} className='px-2 py-2 rounded-md border text-primary-black'>
                    <CgClose />
                </button>
            </div>
            <hr className='mb-6' />

            <div className="px-6 space-y-4 mb-4">
                <Input label="Etablissement" name="company" value={formData?.company} onChange={handleChange} />
                <Input label="Intitulé du poste" name="title" value={formData?.title} onChange={handleChange} />
                <Select label="Type d'emploi" name="job_type" value={formData?.job_type} onChange={handleChange} options={["Temps plein", "Temps partiel","Freelance", "Autre"]} />
                <div className="gr gap-4 items-end">
                    <Input label="Adresse" name="address" value={formData?.address} onChange={handleChange} classContainer='col-span-2' />
                  
                </div>
                <div className="grid grid-cols-4 gap-4 items-end">
                    <Select label="Mois de début" name="start_month" value={formData?.start_month} onChange={handleChange} options={months} />
                    <Select label="Année de début" name="start_year" value={formData?.start_year} onChange={handleChange} options={years} />
                    <Select label="Mois fin" name="end_month" value={formData?.end_month} onChange={handleChange} options={months} />
                    <Select label="Année fin" name="end_year" value={formData?.end_year} onChange={handleChange} options={years} />
                </div>
                <TextAreaEditor label="Description" name="description" value={formData?.description} setValue={setValue} />
            </div>

            <div className="flex items-center justify-end p-6">
                <ButtonBlack isLoading={isLoading} onClick={()=>onSave(formData)} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
                    Enregistrer
                </ButtonBlack>
            </div>
        </Modal>
    );
};

export default Expérience;
